import Swiper from 'swiper';
const HomeSwiper = {
    init() {
        // JavaScript to be fired on the home page
        this._jCareSlider = $('.care__slider');
        this._jCareContainer = $('.jsCareContainer');
        this._jCare = $('.care');

        this._addEvents();
        this.finalize();
    },
    _addEvents() {

    },
    finalize() {
        this.initSwipers();
        this._jCareSlider.css('margin-left', 0);
    },
    initSwipers() {
        new Swiper($('.jsSwiper.jsCare')[0], {
            autoplay: {
                delay: 1000000,
            },
            slidesPerView: 'auto',
            loop: false,
            speed: 600,
            freeMode: true,
            observer: true,
            observeParents: true,
            mousewheel: {
                releaseOnEdges: true,
            },
        });

    },
};

export default HomeSwiper;


// WEBPACK FOOTER //
// ./scripts/modules/home.swiper.js